// Main theme JavaScript file
document.addEventListener('DOMContentLoaded', function() {
  // Theme initialization code here
});

// Collection page sorting and filtering
document.addEventListener('DOMContentLoaded', function() {
  // Sort functionality
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    // Set initial value based on URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sort_by')) {
      sortSelect.value = urlParams.get('sort_by');
    }

    // Handle sort change
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.href;
    });
  }

  // Filter functionality
  const filterForm = document.querySelector('.collection-sidebar');
  const applyFiltersBtn = document.querySelector('.apply-filters');
  const clearFiltersBtn = document.querySelector('.clear-filters');

  if (filterForm && applyFiltersBtn && clearFiltersBtn) {
    // Apply filters
    applyFiltersBtn.addEventListener('click', function() {
      const checkedFilters = filterForm.querySelectorAll('input[type="checkbox"]:checked');
      const url = new URL(window.location.href);
      
      // Clear existing filter params
      Array.from(url.searchParams.keys()).forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });

      // Add new filter params
      checkedFilters.forEach(filter => {
        const filterType = filter.name.split('_')[0];
        const filterValue = filter.value;
        url.searchParams.append(`filter.${filterType}`, filterValue);
      });

      window.location.href = url.href;
    });

    // Clear filters
    clearFiltersBtn.addEventListener('click', function() {
      const url = new URL(window.location.href);
      
      // Remove all filter parameters
      Array.from(url.searchParams.keys()).forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });

      // Uncheck all checkboxes
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = false;
      });

      window.location.href = url.href;
    });

    // Set initial checkbox states based on URL
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        const filterType = key.split('.')[1];
        const checkbox = filterForm.querySelector(`input[name="${filterType}_${value}"]`);
        if (checkbox) {
          checkbox.checked = true;
        }
      }
    });
  }

  // Product image hover effect
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const image = card.querySelector('img');
    if (image) {
      const originalSrc = image.src;
      const hoverSrc = image.dataset.hoverSrc;
      
      if (hoverSrc) {
        card.addEventListener('mouseenter', () => {
          image.src = hoverSrc;
        });
        
        card.addEventListener('mouseleave', () => {
          image.src = originalSrc;
        });
      }
    }
  });
}); 